<template>
  <div id="login" v-bind:style="{height: myHeight + 'px'}">
    <div id="box">
      <div id="logbox">
        <div class="title">
          LOGIN
        </div>
        <div class="text">
          <div>Email</div>
          <b-form-input v-model="email"
                        type="email" name="email" v-validate="'required|email'" autocomplete></b-form-input>
          <div style="color: #f56c6c; padding-bottom: 20px; font-size: 16px">{{ errors.first('email') }}</div>
        </div>
        <div class="text">
          <div>Password</div>
          <b-form-input v-model="pwd"
                        type="password" name="password" v-validate="'required'" autocomplete @keydown.enter.native="onSubmit"></b-form-input>
          <div style="color: #f56c6c; padding-bottom: 20px; font-size: 16px"
               v-for="error in errors.collect('password')">{{ error }}
          </div>
        </div>
      </div>
      <b-btn class="button" @click="onSubmit">
        Accedi
      </b-btn>
    </div>
  </div>
</template>

<script>
  import Bus from './Bus'

  export default {
    name: "login",
    data() {
      return {
        myHeight: window.innerHeight,
        email: '',
        pwd: '',
        profile: []
      }
    },
    methods: {
      onSubmit() {
        this.$validator.validate().then(result => {
          if (result) {
            this.checkCredentials()
          } else {
            // console.log('error submit!!')
          }
        });
      },
      checkCredentials: function () {
        this.$http.get('/ws-admin/login/checkCredentials/' + this.email, {params: {pwd: this.pwd}}).then(response => {
          if (response.body.data === 1) {
            this.accedi()
          } else {
            this.$toasted.show('Email o password errati', {
              theme: 'primary',
              position: 'bottom-right',
              type: 'error',
              duration: 4000
            })
          }
        })
      },
      accedi: function () {
        this.$http.get('/ws-admin/login/profile/' + this.email, {params: {pwd: this.pwd}}).then(response => {
          if (response.body.data) {
            localStorage.setItem('token', response.body.data)
            this.$router.push({name: 'admin'})
            Bus.$emit('admin')
          }
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #login {
    position: relative;
    background-size: cover;
    background-image: url("../../static/image/admin/loginBackground.jpg");
    .form-control {
      margin: auto;
      margin-top: 20px;
      margin-bottom: 20px;
      background-color: @lightBlack;
      color: white;
      border-color: darkslategrey;
    }
    #box {
      padding: 20px;
      position: absolute;
      width: 30%;
      top: 25%;
      left: 35%;
      text-align: center;
      letter-spacing: 1px;
      background-color: @lightBlack;
      border: 1px solid white;
      #logbox {
        margin: auto;
        text-align: left;
        width: 50%;
        .title {
          text-align: center;
          padding-bottom: 20px;
          .set-font-title()
        }
        .text {
          .set-font(@size: 18px)
        }
      }
      .button {
        width: 35%;
        background-color: @myOrange;
        border-color: @borderOrange;
        text-align: center;
        letter-spacing: 1px;
        margin-top: 20px;
        margin-bottom: 20px;
        .set-font()
      }
    }
  }

  @media (max-width: 767px) {
    #login {
      .form-control {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      #box {
        padding: 5px;
        width: 80%;
        top: 25%;
        left: 10%;
        letter-spacing: 1px;
        #logbox {
          width: 85%;
          .title {
            padding-bottom: 20px;
            .set-font-title()
          }
          .text {
            .set-font(@size: 18px)
          }
        }
        .button {
          width: 35%;
          margin-top: 20px;
          margin-bottom: 20px;
          .set-font()
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #login {
      .form-control {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      #box {
        padding: 5px;
        width: 55%;
        top: 25%;
        left: 23%;
        letter-spacing: 1px;
        #logbox {
          width: 85%;
          .title {
            padding-bottom: 20px;
            .set-font-title()
          }
          .text {
            .set-font(@size: 18px)
          }
        }
        .button {
          width: 35%;
          margin-top: 20px;
          margin-bottom: 20px;
          .set-font()
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue